import Headroom from 'headroom.js';

export default function() {
  var header = document.querySelector('body');
  if (header) {
    new Headroom(header, {
      offset: 50,
      tolerance: {
        up: 0,
        down: 0
      },
      classes: {
        initial: 'headroom', // when element is initialised
        pinned: 'headroom-pinned', // when scrolling up
        unpinned: 'headroom-unpinned', // when scrolling down
        top: 'headroom-top', // when above offset
        notTop: 'headroom-not-top' // when below offset
      }
    }).init();
  }
}
